export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const JAMS_BACKEND_URL = import.meta.env.VITE_JAMS_BACKEND_URL!
